import React from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Form from "../../common/Form";
import Row from "../../common/Row";
import NumberInput from "../../common/NumberInput";
import Fieldset from "../../common/Fieldset";
import * as domainConstants from '../../../constants/DomainConstants';
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import FinancieelTableComponent from "../parts/FinancieelTableComponent";
import GenerateGuid from "../../../util/guid";
import { Popup } from 'semantic-ui-react';

const InvesteringenForm = (props) => {
    const {
        model,
        color,
        hoofdCategorien,
        typesInvestering,
        disabled,
        showDeleteModal,
        goToInvesteringEdit,
        goToInvesteringEditWijzig
    } = props;

    function mapOnShowDeleteModal(id) {
        return function (event) {
            showDeleteModal(event, id);
        };
    }

    function mapOnEdit(id) {
        return function (event) {
            goToInvesteringEditWijzig(event, id);
        };
    }

    const isIngediend = model.redenVanStatus.toString() === domainConstants.REDEN_VAN_STATUS_INGEDIEND;
    const noModelsContentSportgerelateerd = "Je hebt nog geen sportgerelateerde investeringen ingegeven voor deze infrastructuur.";
    const noModelsContentNietSportgerelateerd = "Je hebt nog geen niet-sportgerelateerde investeringen ingegeven voor deze infrastructuur.";
    const SubsSportgerelateerdExclBtwTooltip = "Minimale investeringswaarde €500.000: Totaal aan sportgerelateerde investeringen zoals omschreven in het besluit van de Vlaamse regering 16-6-2017";

    let totaalAlleSubsidieerbareInvesteringenExclBtw = 0;
    let totaalAlleSubsidieerbareInvesteringenInclBtw = 0;
    let totaalAlleInvesteringen = 0;

    const content = model.infrastructuren.map((infrastructuur) => {
        const sportgerelateerdeInvesteringen = infrastructuur.investeringen ? infrastructuur.investeringen.filter(inv => inv.type === domainConstants.INVESTERING_TYPE_SPORTGERELATEERD) : [];
        const nietSportgerelateerdeInvesteringen = infrastructuur.investeringen ? infrastructuur.investeringen.filter(inv => inv.type !== domainConstants.INVESTERING_TYPE_SPORTGERELATEERD).sort(function (a, b) { return a.type - b.type; }) : [];

        if (infrastructuur.investeringen)
            infrastructuur.investeringen.forEach(x => totaalAlleInvesteringen += x.bedragExclusiefBTW);

        sportgerelateerdeInvesteringen.forEach(s => {
            if (s.totaalSubsidieerbaarBedrag > 0) {
                totaalAlleSubsidieerbareInvesteringenExclBtw += s.bedragExclusiefBTW;
                totaalAlleSubsidieerbareInvesteringenInclBtw += s.totaalSubsidieerbaarBedrag;
            }
        });

        if(model.typeDossier == domainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_RENOVATIE)
        {
            nietSportgerelateerdeInvesteringen.forEach(s => {
                if (s.totaalSubsidieerbaarBedrag > 0) {
                    totaalAlleSubsidieerbareInvesteringenExclBtw += s.bedragExclusiefBTW;
                    totaalAlleSubsidieerbareInvesteringenInclBtw += s.totaalSubsidieerbaarBedrag;
                }
            });
        }

        totaalAlleSubsidieerbareInvesteringenInclBtw = Math.round(totaalAlleSubsidieerbareInvesteringenInclBtw * 100) / 100;

        const tableSettingsSportgerelateerd = {
            tableHeaders: ["HOOFDCATEGORIE", "OMSCHRIJVING", "TOTAAL (Excl BTW)", "TOTAAL subsidieerbaar", ""],
            tableHeaderSizes: [4, 4, 1, 1, 1],
            noModelsContent: noModelsContentSportgerelateerd,
            hasRows: sportgerelateerdeInvesteringen.length > 0,
            tableRows: sportgerelateerdeInvesteringen.map((inv, i) => {
                const hoofdCategorie = hoofdCategorien.find(m => m.value === inv.hoofdcategorie.toString());
                const hoofdCategorieNaam = hoofdCategorie ? hoofdCategorie.label : null;

                return (<tr key={"Sportgerelateerd_" + i}>
                    <td>{hoofdCategorieNaam}</td>
                    <td >{inv.omschrijvingStelpost}</td>
                    <td>{"€ " + inv.bedragExclusiefBTW.toLocaleString('nl-BE')}</td>
                    <td>{"€ " + inv.totaalSubsidieerbaarBedrag.toLocaleString('nl-BE')}</td>
                    <td>
                        {isIngediend ? null : <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-trash fa-fw" onClick={mapOnShowDeleteModal(inv.id)} />} content="verwijder investering" /></span>}
                        <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={mapOnEdit(inv.id)} />} content="wijzig investering" /></span>
                    </td>
                </tr >);
            })
        };
        const tableSettingsNietSportgerelateerd = {
            tableHeaders: ["AARD", "HOOFDCATEGORIE", "OMSCHRIJVING", "TOTAAL (Excl BTW)", ""],
            tableHeaderSizes: [2, 2, 2, 1, 1],
            noModelsContent: noModelsContentNietSportgerelateerd,
            hasRows: nietSportgerelateerdeInvesteringen.length > 0,
            tableRows: nietSportgerelateerdeInvesteringen.map((inv, i) => {
                const aard = typesInvestering.find(m => m.value === inv.type.toString());
                const aardNaam = aard ? aard.label : null;
                const hoofdCategorie = hoofdCategorien.find(m => m.value === inv.hoofdcategorie.toString());
                const hoofdCategorieNaam = hoofdCategorie ? hoofdCategorie.label : null;
                return (<tr key={"nietSportgerelateerd_" + i}>
                    <td>{aardNaam}</td>
                    <td>{hoofdCategorieNaam}</td>
                    <td >{inv.omschrijvingStelpost}</td>
                    <td>{"€ " + inv.bedragExclusiefBTW.toLocaleString('nl-BE')}</td>
                    <td>
                        {isIngediend ? null : <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-trash fa-fw" onClick={mapOnShowDeleteModal(inv.id)} />} content="verwijder investering" /></span>}
                        <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={mapOnEdit(inv.id)} />} content="wijzig investering" /></span>
                    </td>
                </tr >);
            })
        };

        const contentSportgerelateerd = (<div><FieldsetSubHeader>Sportgerelateerd</FieldsetSubHeader>
            <FinancieelTableComponent
                settings={tableSettingsSportgerelateerd}
                disabled={disabled} /></div>);


        const contentNietSportgerelateerd = (<div><FieldsetSubHeader>Niet-sportgerelateerde investeringen</FieldsetSubHeader>
            <FinancieelTableComponent
                settings={tableSettingsNietSportgerelateerd}
                disabled={disabled} /></div>);

        const uniqueId = GenerateGuid();

        return (<div key={"INFRASTRUCTUUR_" + uniqueId}>
            <Fieldset title={infrastructuur.soortInfrastructuur + ": " + infrastructuur.naam}>
                {contentSportgerelateerd}
                {contentNietSportgerelateerd}
            </Fieldset>
        </div>);
    });

    return (<Section title={domainConstants.FinancieelTitels.FinancieleHaalbaarheid} color={color}>
        <Form
            title="Overzicht investeringen"
            name="overzichtInvesteringen"
            leftButtonLabel={isIngediend ? null : "Voeg investering toe"}
            onLeftButtonClick={goToInvesteringEdit}
            isNotRequired>
            {content}

            <Row>
                <NumberInput
                    name="opgegevenSportgerelateerdInvesteringsbedrag"
                    label="Totaal alle subsidieerbare sportgerelateerde investeringen (Excl BTW)"
                    value={totaalAlleSubsidieerbareInvesteringenExclBtw}
                    disabled
                    roundToTwoDecimals
                    isValuta
                    size={6}
                    tooltip={SubsSportgerelateerdExclBtwTooltip}
                />
                <NumberInput
                    name="totaalSubsidieerbaarSportgerelateerdInvestering"
                    label="Totaal alle subsidieerbare sportgerelateerde investeringen (Incl BTW)"
                    value={totaalAlleSubsidieerbareInvesteringenInclBtw}
                    disabled
                    roundToTwoDecimals
                    isValuta
                    size={6} />
            </Row>
            <Row>
                <NumberInput
                    name="totaalOpgegevenInvesteringsbedrag"
                    label="TOTAAL ALLE INVESTERINGEN (EXCL BTW)"
                    value={totaalAlleInvesteringen}
                    disabled
                    roundToTwoDecimals
                    isValuta
                    size={12} />
            </Row>
        </Form>
    </Section>);
};

InvesteringenForm.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    hoofdCategorien: PropTypes.array,
    typesInvestering: PropTypes.array,
    model: PropTypes.object,
    showDeleteModal: PropTypes.func,
    goToInvesteringEdit: PropTypes.func.isRequired,
    goToInvesteringEditWijzig: PropTypes.func.isRequired
};

export default InvesteringenForm;